module.exports = __webpack_public_path__ + "static/media/lightbulb.f1f436a7.gif";